import type { ExpenseCategory, Trip } from '../../types';

/** The categories an expense can carry, in the order the pickers show them. */
export const EXPENSE_CATEGORIES: ExpenseCategory[] = [
  'ACCOMMODATION', 'FLIGHTS', 'FOOD', 'ACTIVITIES', 'TRANSPORT', 'FUEL', 'PARKING', 'CASH', 'OTHER',
];

/**
 * The date a new expense starts on: today when the trip is happening, the trip's
 * first day otherwise — today would land outside the range for a future or past
 * trip. Shared by the manual form and the AI review so the two can't drift.
 */
export function defaultExpenseDate(trip: Trip): string {
  const start = trip.startDate.slice(0, 10);
  const today = new Date().toISOString().split('T')[0];
  return today >= start && today <= trip.endDate.slice(0, 10) ? today : start;
}
